import { BrowserApiConfigService } from './services/api-config/api-config.server.browser';
import { BrowserAnalyticsService } from './services/analytics/analytics.browser.service';
import {BrowserTransferStateModule} from '@angular/platform-browser';
import {NgModule, Injector, APP_INITIALIZER} from '@angular/core';

import {AppModule} from './app.module';
import {AppComponent} from './app.component';

import {BrowserCacheModule, MemoryCacheService} from '@ngx-cache/platform-browser';
import {CACHE} from '@ngx-cache/core';
import {CookieModule} from 'ngx-cookie';
import {ChatService} from './services/chat.service';
import {BrowserChatService} from './services/chat/chat.browser.service';
import {BrowserStyleService} from './services/style/browser-style.service';
import {BrowserLanguageService} from './services/language/browser-language.service';
import {LanguageService} from './services/language/language.service';
import {StyleService} from './services/style/style.service';
import {APP_CONFIG, APP_DI_CONFIG} from './app-config.constants';
import {ConfirmationService} from './services/confirmation/confirmation.service';
import {BrowserResizeService} from './services/resize/browser-resize.service';
import {ResizeService} from './services/resize/resize.service';
import {DeviceService} from './services/device/device.service';
import {BrowserUserService} from './services/user/browser-user.service';
import {DomManipulationService} from './services/dom-manipulation/dom-manipulation.service';
import {BrowserConfirmationService} from './services/confirmation/browser-confirmation.service';
import {BrowserDomManipulationService} from './services/dom-manipulation/browser-dom-manipulation.service';
import {BrowserDeviceService} from './services/device/browser-device.service';
import {UserService} from './services/user.service';
import {IonRangeSliderModule} from 'ng2-ion-range-slider';
import { LoggerService } from './services/logger/logger.service';
import { ResponseService } from './services/response/response.service';
import { BrowserResponseService } from './services/response/response.browser.service';
import { BrowserLoggerService } from './services/logger/logger.browser.service';
import { AnalyticsService } from './services/analytics/analytics.service';
import { OdometerService } from './services/odometer.service';
import { BrowserOdometerService } from './services/odometer/odometer.browser.service';
import { TranslateService } from '@ngx-translate/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { ApiConfigService } from './services/api-config/api-config.service';

// https://github.com/ngx-translate/core/issues/517
export function appInitializerFactory(translate: TranslateService, injector: Injector) {
  return () => new Promise<any>((resolve: any) => {
    const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
    locationInitialized.then(() => {
      const langToSet = 'en';
      translate.setDefaultLang('en');
      translate.use(langToSet).subscribe(() => {
        // console.info(`Successfully initialized '${langToSet}' language.'`);
      }, err => {
        // console.error(`Problem with '${langToSet}' language initialization.'`);
      }, () => {
        // this will be resolved when translate service has initialized
        resolve(null);
      });
    });
  });
}

@NgModule({
  imports: [
    // The AppServerModule should import your AppModule followed
    // by the ServerModule from @angular/platform-server.
    AppModule,
    CookieModule.forRoot(),
    BrowserCacheModule.forRoot([
    {
        provide: CACHE,
        useClass: MemoryCacheService
    }
    ]),
    BrowserTransferStateModule
  ],
  // Since the bootstrapped component is not inherited from your
  // imported AppModule, it needs to be repeated here.
  bootstrap: [AppComponent],
  providers: [
    {
      provide: ChatService,
      useClass: BrowserChatService
    },
    {
      provide: LanguageService,
      useClass: BrowserLanguageService
    },
    {
      provide: ResizeService,
      useClass: BrowserResizeService
    },
    {
      provide: StyleService,
      useClass: BrowserStyleService
    },
    {
      provide: DeviceService,
      useClass: BrowserDeviceService
    },
    {
      provide: UserService,
      useClass: BrowserUserService
    },
    {
      provide: ConfirmationService,
      useClass: BrowserConfirmationService
    },
    {
      provide: DomManipulationService,
      useClass: BrowserDomManipulationService
    },
    {
      provide: LoggerService,
      useClass: BrowserLoggerService
    },
    {
      provide: OdometerService,
      useClass: BrowserOdometerService
    },
    {
      provide: ResponseService,
      useClass: BrowserResponseService
    },
    {
      provide: AnalyticsService,
      useClass: BrowserAnalyticsService
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, Injector],
      multi: true
    },
    {
      provide: ApiConfigService,
      useClass: BrowserApiConfigService
    }
  ]
})
export class AppBrowserModule {}
